import { SVG_DOWNLOAD_OUTLINED } from '@getgo/chameleon-icons'
import { html, LitElement, property } from 'lit-element'
import { t } from '../../../directives/translate/translate'
import updateButtonStyles from './update-chip.styles.scss'

export class GoToUpdateChip extends LitElement {
  static readonly tagName = 'goto-update-chip'
  @property({ type: Number }) updateAge = 0

  static get styles() {
    return updateButtonStyles
  }

  render() {
    return html`<chameleon-chip
      ><chameleon-svg class="update">${SVG_DOWNLOAD_OUTLINED}</chameleon-svg>${t('Update Available')}</chameleon-chip
    >`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [GoToUpdateChip.tagName]: GoToUpdateChip
  }
}
